import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';

import {interval, startWith, Subscription, takeWhile} from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import {NotificationService} from '@commons/services/notification/notification.service';
import {AppNotification, AppNotificationTypes} from '@commons/models/other/app-notification.model';
import {MapEventsService} from "@commons/services/map/map-events.service";
import {NewDataStoreService} from '@shared/services/new-data-store.service';

@Component({
    selector: 'tk-notification',
    templateUrl: './notification.component.html',
    styleUrls: ['./notification.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class NotificationComponent implements OnInit, OnDestroy {

    public isVisible = false;
    public msg?: AppNotification;
    public lineWidth = 100;

    private sub?: Subscription;
    private timoutInSeconds = 6;
    private currentTimeout: any;
    private timeLineSubsc: Subscription = new Subscription();
    public readonly MESSAGE_TYPE = AppNotificationTypes;

    public vehicleName = this.translate.instant('events-list.unknown-vehicle');
    public driverName = this.translate.instant('events-list.unknown-driver');

    public openVehicle(vehicleId: number) {
        this.mapEventsService.emmitVehicleClicked(vehicleId);
    }

  constructor(
    private $msg: NotificationService,
    private newDataStoreService: NewDataStoreService,
    private mapEventsService: MapEventsService,
    private translate: TranslateService,
  ) { }

    ngOnInit(): void {
        this.sub = this.$msg
            .getSubject()
            .subscribe(notify => {

                notify.opts = notify.opts || {};

                // wyłapanie końca sesji
                if ((notify.type === AppNotificationTypes.ERROR || notify.type === AppNotificationTypes.APP_ERROR)
                    && notify && notify.data && notify.data.ErrorCode === 4
                ) {
                    return;
                }

                // inne
                if (!this.isVisible || (notify.type === AppNotificationTypes.ERROR || notify.type === AppNotificationTypes.APP_ERROR)) {
                    // wyczyszczenie
                    if (this.currentTimeout) {
                        clearTimeout(this.currentTimeout);
                    }

                    // przepisanie wartosci]
                    this.msg = notify;
                    this.isVisible = true;
                    this.countDownVisibleStatus();

                    // jezeli tylko INFO to wlaczamy
                    if (this.msg.type === AppNotificationTypes.INFO || this.msg.type === AppNotificationTypes.APP_SUCCESS) {

                        // Get names of vehicle and driver if any
                        if (notify.driverId) {
                          const driver = this.newDataStoreService.getDriverById(notify.driverId);
                          if (driver) {
                            this.driverName = `${driver.FN} ${driver.LN}`;
                          }
                        }
                        if (notify.vehicleId) {
                          const vehicle = this.newDataStoreService.getVehicleById(notify.vehicleId);
                          if (vehicle) {
                            this.vehicleName = vehicle.Nm!;
                          }
                        }

                        if (notify.opts.autoClose !== false) {
                            this.currentTimeout = setTimeout(() => {
                                this.closeMessage();
                            }, this.timoutInSeconds * 1000);
                        }
                    } else {
                        // tytul
                        switch (this.msg.type) {
                            case AppNotificationTypes.APP_ERROR:
                                this.msg.title = notify.title || this.translate.instant('vehicle-list-item.etoll-not-sending');
                                break;
                            case AppNotificationTypes.APP_WARN:
                                this.msg.title = notify.title || this.translate.instant('warrning');
                                break;
                            case AppNotificationTypes.APP_INFO:
                                this.msg.title = notify.title || this.translate.instant('information');
                                break;
                            default:
                                break;
                        }


                        // problem
                        if (!this.msg.text && this.msg.data) {
                            switch (this.msg.data.ErrorCode) {
                                //    Ok = 0,
                                case 0:
                                    this.msg.text = 'Opercja przebiegła pomyślnie';
                                    break;
                                //    InternalError = 1, // wewnętrzny błąd usługi
                                case 1:
                                    this.msg.text = 'Wystąpił błąd wewnętrzny serwera';
                                    break;
                                //    NotValidCredentials = 2, // nieprawidłowe dane uwierzytelniające
                                case 2:
                                    this.msg.text = 'E-mail lub hasło jest niepoprawne';
                                    break;
                                //    NoAccessToData = 3, // brak dostępu do danych
                                case 3:
                                    this.msg.text = 'Brak dostępu do danych';
                                    break;
                                //    NoSessionOrExpired = 4, //brak sesji lub sesja wygasła
                                case 4:
                                    this.msg.text = 'Brak sesji lub sesja wygasła';
                                    break;
                                //    FailToLoadProfileContactData = 5, //nie udało się pobrać danych kontaktowych z xml
                                case 5:
                                    this.msg.text = 'Nie udało się pobrać danych kontaktowych z xml';
                                    break;
                                //    DataFail = 6, //nieprawidłowe dane wejściowe
                                case 6:
                                    this.msg.text = 'Nieprawidłowe dane wejściowe';
                                    break;
                                //    ResetPasswordTokenIsExpired = 7, //token do resetu hasła wygasł
                                case 7:
                                    this.msg.text = 'Token do resetu hasła wygasł';
                                    break;
                                //    ResetPasswordTokenNotExist = 8, //nie znaleziono tokenu do resetu hasła
                                case 8:
                                    this.msg.text = 'Nie znaleziono tokenu do resetu hasła';
                                    break;
                                //    OldPasswordIncorrect = 9, //stare hasło jest niepoprawne
                                case 9:
                                    this.msg.text = 'Błędne hasło';
                                    break;
                                //    OldPasswordIsEmpty = 10, //stare hasło jest puste
                                case 10:
                                    this.msg.text = 'Hasło jest puste';
                                    break;
                                //    ResetPasswordTokenIsEmpty = 11, //token do resetu hasła jest pusty
                                case 11:
                                    this.msg.text = 'Token do resetu hasła jest pusty';
                                    break;
                                //    PersonNotFound = 12,
                                case 12:
                                    this.msg.text = 'Nie znaleziono osoby';
                                    break;
                                //    SearchEngineNotFound = 13,
                                case 13:
                                    this.msg.text = 'Nie znaleziono';
                                    break;
                                // inne
                                default:
                                    this.msg.text = this.msg.data.ErrorDescription || 'Brak komunikatu';
                                    if (this.msg.data.ErrorData && this.msg.data.ErrorData.status === 0) {
                                        this.msg.text = 'Brak połaczenia z serwerem lub podany adres nie został znaleziony';
                                    }
                                    break;
                            }
                        }

                        if (notify.opts.autoClose !== false) {
                            this.currentTimeout = setTimeout(() => {
                                this.closeMessage();
                            }, this.timoutInSeconds * 1000);
                        }
                    }
                }
            });
    }

    ngOnDestroy(): void {
        if (this.sub) {
            this.sub.unsubscribe();
        }
        this.timeLineSubsc.unsubscribe();
    }

    public closeMessage(): void {
        this.isVisible = false;
        this.msg = undefined;
    }

    private resetLineTime(): void {
        this.timeLineSubsc.unsubscribe();
        this.lineWidth = 100;
    }

    private countDownVisibleStatus(): void {
        this.resetLineTime();
        const howMuchCountDownPercentWithPerSecond = 20;
        let isFirstEmission = true;

        const interval$ = interval(1000);
        this.timeLineSubsc = interval$
        .pipe(
            startWith(0),
            takeWhile(() => {
                if (this.lineWidth <= 0) {
                    this.closeMessage();
                }
                return this.lineWidth > 0;
            })
        )
        .subscribe(() => {
            if (!isFirstEmission) {
                this.lineWidth = Math.max(this.lineWidth - howMuchCountDownPercentWithPerSecond, 0);
            }
            isFirstEmission = false;
        });
    }

}
